import { DEFAULT_LOCALE } from "@/common/date.common";
import React from "react";
import { CurrencyAmount } from "@/components/ui/CurrencyAmount";

export const formatAmount = (
  amount: number,
  currency: string
): React.ReactNode => React.createElement(CurrencyAmount, { amount, currency });

export const formatMonetaryAmount = (amount: number): number => {
  if (typeof amount !== "number") {
    return 0;
  }

  const finalValue = amount / 100;

  return finalValue;
};

export const convertToMonetaryAmount = (amount: number) => {
  if (typeof amount !== "number") {
    return 0;
  }

  return Math.round(amount * 100);
};

/**
 * Formats a number with commas for display (e.g., 3500 -> "3,500")
 */
export const formatNumberWithCommas = (amount: number): string => {
  return amount.toLocaleString(DEFAULT_LOCALE);
};

/**
 * Formats a number in short form for tight spaces (e.g., 1234 -> "1.2K", 2500000 -> "2.5M")
 */
export const formatCompactNumber = (value: number): string =>
  new Intl.NumberFormat(DEFAULT_LOCALE, { notation: "compact", maximumFractionDigits: 1 }).format(value);

/**
 * Formats a 0-100 percentage (e.g., 52.4 -> "52%", 3.25 -> "3.3%")
 */
export const formatPercent = (value: number): string =>
  `${value.toLocaleString(DEFAULT_LOCALE, { maximumFractionDigits: value !== 0 && Math.abs(value) < 10 ? 1 : 0 })}%`;
